import { AddProperty } from '@features/ForestOwner/Property/AddProperty'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/property/add')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Legg til ny eiendom',
  },
})

function RouteComponent() {
  return <AddProperty />
}
